import { left, right } from '@sweet-monads/either';
import type { Either } from '@sweet-monads/either';

import { AbstractError } from '@/domain/errors/abstract-error.js';
import { ServerError } from '@/domain/errors/server-error.js';
import type { AiModelsCatalogModel } from '@/domain/models/ai-model.js';
import type { AiModelsRepository } from '@/domain/repositories/ai-models-repository.js';
import type { ListAiModels } from '@/domain/use-cases/ai-models.js';

export class ListAiModelsUseCase implements ListAiModels {
    constructor(private readonly repository: AiModelsRepository) {}

    public async execute(): Promise<Either<AbstractError, AiModelsCatalogModel>> {
        try {
            return right(await this.repository.listModels());
        } catch (error) {
            if (error instanceof AbstractError) {
                return left(error);
            }
            return left(new ServerError((error as Error).message));
        }
    }
}
